import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { getAdditionalCost, getDyeCost, getKnitCost, getOtherCost } from "../../../API/Ventas/Cotizaciones/CotizacionesRequest";


// ------------------ COMPONENTES DE NECESARIOS--------------------------
import KnitCostCRUD from "./CRUD/KnitCostCRUD"
import DyeCostCRUD from "./CRUD/DyeCostCRUD"
import AdditionalCostCRUD from "./CRUD/AdditionalCostCRUD"
import OthersCostCRUD from './CRUD/OthersCostCRUD'

const CotizacionesScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [dialogKnit, setDialogKnit] = useState(false);
  const [dialogDyeC, setDialogDyeC] = useState(false);
  const [dialogAdditional, setDialogAdditional] = useState(false);
  const [dialogOther, setDialogOther] = useState(false);

  const [selected, setSelected] = useState(null)


  const getInfo = async () => {
    setLoading(true);

    let result;
    switch (activeIndex) {
      case 0:
        result = await getKnitCost();
        break;
      case 1:
        result = await getDyeCost();
        break;
      case 2:
        result = await getAdditionalCost();
        break;
      case 3:
        result = await getOtherCost();
        break;
      default:
        console.warn('Invalid activeIndex');
        setLoading(false);
        return;
    }

    setData(result);
    setLoading(false);
  };

  const openDialog = () => {
    switch (activeIndex) {
      case 0:
        setDialogKnit(true);
        break;
      case 1:
        setDialogDyeC(true);
        break;
      case 2:
        setDialogAdditional(true);
        break;
      case 3:
        setDialogOther(true);
        break;
      default:
        console.warn('Invalid index for dialog');
        break;
    }
  };

  //----COLUMNAS----

  const columsKnitCost = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdKnitCost',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      Format: "DateTime",
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
      Sumary: 'count',
    },
    {
      field: 'Price',
      header: 'Precio',
      headerEn: 'Price',
      className: 'small',
      Format: 'Currency',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Categoría de Estilo',
      headerEn: 'Style Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Hilo',
      headerEn: 'Yarn',
      field: 'Hilo',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Estilo de Tejido',
      headerEn: 'Fabric Style',
      field: 'FabricStyle',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Unidad',
      headerEn: 'Unit',
      field: 'UnitName',
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'AllYarn',
      headerEn: 'AllYarn',
      field: 'AllYarn',
      className: 'Xsmall',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
      Format: 'Checkbox',
    },
    {
      header: 'SinRango',
      headerEn: 'SinRango',
      field: 'SinRango',
      className: 'Xsmall',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
      Format: 'Checkbox',
    },
    // {
    //   header: 'Descripción Estilo',
    //   headerEn: 'DescripctionStyle',
    //   field: 'DescripctionStyle',
    //   className: 'large',
    // },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdKnitCost",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogKnit(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ]

  const columsDyeCost = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdDyeCost',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      Sumary: 'count',
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Precio',
      headerEn: 'Price',
      field: 'Price',
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
      Format: 'Currency',
    },
    {
      header: ' Estilo de Categoría',
      headerEn: 'Style Category',
      field: 'StyleCategory',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Hilo',
      headerEn: 'Yarn',
      field: 'Hilo',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
    },
    {
      header: 'Tipo de Colorante',
      headerEn: 'Dye Type',
      field: 'DyeType',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
      className: 'large',
      flex: 1,
      minWidth: 200,
    },
    {
      header: 'Densidad',
      headerEn: 'Density',
      field: 'Density',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
      className: 'large',
    },
    {
      header: 'Unidad',
      headerEn: 'Unit',
      field: 'UnitName',
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeC(true)
        setSelected(data);
      },
    },
    {
      header: 'AllYarn',
      headerEn: 'AllYarn',
      field: 'AllYarn',
      className: 'Xsmall',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
      Format: 'Checkbox',
    },
    {
      header: 'SinRango',
      headerEn: 'SinRango',
      field: 'SinRango',
      className: 'Xsmall',
      onCellDoubleClicked: ({ data }) => {
        setDialogKnit(true)
        setSelected(data);
      },
      Format: 'Checkbox',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'small',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdDyeCost",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogDyeC(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ]

  const columsAdditionalCost = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdAdditionalCost',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setDialogAdditional(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setDialogAdditional(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Precio',
      headerEn: 'Price',
      field: 'Price',
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        setDialogAdditional(true)
        setSelected(data);
      },
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogAdditional(true)
        setSelected(data);
      },
      flex:1,
      minWidth: 200,
    },
    {
      header: 'Unidad',
      headerEn: 'Unit',
      field: 'UnitName',
      onCellDoubleClicked: ({ data }) => {
        setDialogAdditional(true)
        setSelected(data);
      },
      className: 'small',
    },
    {
      header: 'Costo Proceso',
      headerEn: 'ProcessCost',
      field: 'ProcessCost',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdAdditionalCost",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogAdditional(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsOtherCost = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdAdditionalCost',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setDialogOther(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setDialogOther(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Precio',
      headerEn: 'Price',
      field: 'Price',
      className: 'small',
      onCellDoubleClicked: ({ data }) => {
        setDialogOther(true)
        setSelected(data);
      },
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogOther(true)
        setSelected(data);
      },
      flex:1,
      minWidth: 200,
    },
    {
      header: 'Unidad',
      headerEn: 'Unit',
      field: 'UnitName',
      onCellDoubleClicked: ({ data }) => {
        setDialogOther(true)
        setSelected(data);
      },
      className: 'small',
    },
    {
      header: 'Costo Proceso',
      headerEn: 'ProcessCost',
      field: 'ProcessCost',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdAdditionalCost",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogOther(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  //----TABLAS-----
  const tableKnitCost = {
    Columns: columsKnitCost,
    Data: data,
  }

  const tableDyeCost = {
    Columns: columsDyeCost,
    Data: data,
  }

  const tableAdditionalCost = {
    Columns: columsAdditionalCost,
    Data: data,
  }
  
  const tableOtherCost = {
    Columns: columsOtherCost,
    Data: data,
  }

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "cotizacionesCost", config.language));
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "cotizacionesCost", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nuevo"
              onClick={(e) => openDialog()}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "knitCost", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableKnitCost} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "dyeCost", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableDyeCost} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "additionalCost", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableAdditionalCost} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "OtherCost", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableOtherCost} />
                </div>
              </TabPanel>

            </TabView>
          </div>
        }
      />

      {dialogKnit && (
        <KnitCostCRUD
          dialog={dialogKnit}
          setDialog={setDialogKnit}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogDyeC && (
        <DyeCostCRUD
          dialog={dialogDyeC}
          setDialog={setDialogDyeC}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogAdditional && (
        <AdditionalCostCRUD
          dialog={dialogAdditional}
          setDialog={setDialogAdditional}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogOther && (
        <OthersCostCRUD
          dialog={dialogOther}
          setDialog={setDialogOther}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default CotizacionesScreen;
